export default "__VITE_ASSET__GCtXCHEh__"